import React from 'react'
import PropTypes from 'prop-types'
import { FormGroup, Input, Button, Label } from 'reactstrap'
import { Field } from 'formik'

export default class FormikToggleField extends React.Component {
  static propTypes = {
    label: PropTypes.string,
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func,
    disabled: PropTypes.bool,
    readOnly: PropTypes.bool,
    validate: PropTypes.func,
    size: PropTypes.oneOf(['xs', 'sm', 'md', 'lg']),
  }
  static defaultProps = {
    onLabel: 'On',
    offLabel: 'Off',
    onStyle: 'success',
    offStyle: 'light',
    size: 'md',
  }

  toggleCheck = e => {
    e.stopPropagation()
    if (this.props.disabled) return
    this.props.onChange(this.props)
  }

  render = () => {
    const props = this.props
    const {
      name,
      label,
      isChecked,
      disabled,
      onStyle,
      offStyle,
      size,
      onLabel,
      offLabel,
    } = props
    const btnSize = size === 'xs' || size === 'lg' ? `btn-${size}` : ''
    return (
      <FormGroup>
        <Label>{label || props.children}</Label>
        <div className="checkbox-toggle">
          <label>
            <Button
              className={`toggle ${isChecked ? 'on' : 'off'} ${btnSize}`}
              color={isChecked ? onStyle : offStyle}
              disabled={disabled || props.isSubmitting}
              type="button"
            >
              <span className="spacer">{isChecked ? onLabel : offLabel}</span>
              <Input
                aria-label={label}
                checked={isChecked}
                id={name}
                name={name}
                tag={Field}
                type="checkbox"
              />
              <div className="toggle-group" onClick={this.toggleCheck}>
                <div className={`toggle-on btn btn-${onStyle} ${btnSize}`}>
                  {onLabel}
                </div>
                <div className={`toggle-off btn btn-${offStyle} ${btnSize}`}>
                  {offLabel}
                </div>
                <span className="toggle-handle btn btn-light" />
              </div>
            </Button>
          </label>
        </div>
      </FormGroup>
    )
  }
}
